import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=1818c948&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=1818c948&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818c948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1818c948')) {
      api.createRecord('1818c948', component.options)
    } else {
      api.reload('1818c948', component.options)
    }
    module.hot.accept("./videoPlayer.vue?vue&type=template&id=1818c948&scoped=true", function () {
      api.rerender('1818c948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/videoPlayer.vue"
export default component.exports